import { app } from '../../../../bootstrap/core';
import { formButtonsComponent } from './formButtons.component';

app.component('fdFormButtons', formButtonsComponent);
